// extracted by mini-css-extract-plugin
module.exports = {"listItem":"Px9GC","content":"Jj0nF","image":"oeWT_","playDuration":"MsHyf","details":"xjHNZ","smallText":"CzrAH","category":"pco7_","title":"HVl7U","fakeLink":"YGbDq"};